import React from 'react';
import PropTypes from 'prop-types';

import Align from '@marvelapp/marvel-ui/align';
import Spacing from '@marvelapp/marvel-ui/spacing';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';

import Quote from '../../Quote';

export default function QuoteBlock({ align, children, caption }) {
  return (
    <Spacing size="m" sizeS="l" sizeM="xl" position="topBottom" type="margin">
      <PageWrap size="m">
        <Spacing sizeM="xl" position="leftRight" type="padding">
          <Spacing sizeM="xl" position="leftRight" type="padding">
            <Align type={align}>
              <Quote
                boldContent={children}
                caption={caption}
                headingSize="xxxl"
              />
            </Align>
          </Spacing>
        </Spacing>
      </PageWrap>
    </Spacing>
  );
}

QuoteBlock.propTypes = {
  align: PropTypes.oneOf(['left', 'right', 'center']),
  caption: PropTypes.string,
  children: PropTypes.node,
};

QuoteBlock.defaultProps = {
  align: 'center',
};



// WEBPACK FOOTER //
// ./src/components/modules/ContentBlocks/Quote/index.js